module.exports = __webpack_public_path__ + "static/img/fish15.946ee88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish15.png
// module id = XT5X
// module chunks = 0